import { PROTECTED_APIS } from "services/configureAuthInterceptors";

export interface StoredTokens {
  token: string;
  refreshToken: string;
  tokenExpiration: number;
  refreshTokenExpiration: number;
  userId: string;
}

const MINUTE_IN_MS = 60 * 1000;

export function calcTokenExpirationDate(expiresInMinutes: number): number {
  if (!Number.isFinite(expiresInMinutes) || expiresInMinutes <= 0) {
    return 0;
  }

  return Date.now() + expiresInMinutes * MINUTE_IN_MS;
}

export function getRefreshTokenExpirationInMinutes(): number {
  const refreshTokenExpiration = Number(
    localStorage.getItem("@ctech:refreshTokenExpiration") || 0,
  );

  return Number.isFinite(refreshTokenExpiration) && refreshTokenExpiration > 0
    ? refreshTokenExpiration
    : 0;
}

export function getRefreshTokenExpirationAt(): number {
  const expirationAt = Number(
    localStorage.getItem("@ctech:refreshTokenExpirationAt") || 0,
  );

  if (Number.isFinite(expirationAt) && expirationAt > 0) {
    return expirationAt;
  }

  return 0;
}

export function isRefreshTokenExpired(): boolean {
  const refreshTokenExpirationAt = getRefreshTokenExpirationAt();

  if (!refreshTokenExpirationAt) {
    return false;
  }

  return refreshTokenExpirationAt <= Date.now();
}

export function updateApiAuthorizationHeader(token: string) {
  const bearerHeader = `Bearer ${token}`;

  PROTECTED_APIS.forEach((api) => {
    api.defaults.headers.common.authorization = bearerHeader;
  });
}

export function persistAuthTokens({
  token,
  refreshToken,
  tokenExpiration,
  refreshTokenExpiration,
  userId,
}: StoredTokens) {
  const tokenExpirationAt = calcTokenExpirationDate(tokenExpiration);
  const refreshTokenExpirationAt = calcTokenExpirationDate(
    refreshTokenExpiration,
  );

  localStorage.setItem("@ctech:token", token);
  localStorage.setItem("@ctech:refreshToken", refreshToken);
  localStorage.setItem("@ctech:tokenExpiration", tokenExpiration.toString());
  localStorage.setItem(
    "@ctech:tokenExpirationAt",
    tokenExpirationAt.toString(),
  );
  localStorage.setItem(
    "@ctech:refreshTokenExpiration",
    refreshTokenExpiration.toString(),
  );
  localStorage.setItem(
    "@ctech:refreshTokenExpirationAt",
    refreshTokenExpirationAt.toString(),
  );
  localStorage.setItem("@ctech:userId", userId);

  updateApiAuthorizationHeader(token);
}
